module.exports = __webpack_public_path__ + "media/packs/CarContent/components/sold-text-9b406ee5f1107e786b4177c4cfa2a921.svg";